
export default {
    path: 'viewer',
    component: () => import("./Viewer"),
    name: 'viewer',
    props: (route) => ({
        pid: route.params.pid,
    }),
}